import sample_1 from './sample1.jpeg';

export const dynamicIndustryImageKfz3Impressions = {
    sample_1,
};
